<template>
  <div class="con7">
    <div class="container">
      <p class="text-title">
        100% 자체 개발한<br />300여 개의<br class="br-m" />
        상황별 대화 훈련
      </p>
      <p class="text-sub">
        AI튜터 Plus의 모든 콘텐츠는<br />에듀테크 선도기업 캐럿솔루션즈의<br
          class="br-m"
        />
        스마트컨텐츠연구소에서 제작됩니다.<br /><span
          >20여 년의 교육 서비스 노하우와<br class="br-m" />
          최고의 기술인 AI가 만나<br class="br-m" />
          차별화된 학습을 제공</span
        >합니다.
      </p>
    </div>
    <div class="marquee"></div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.con7 {
  padding: 86px 0;

  @media screen and (min-width: 1200px) {
    padding: 174px 0;
  }

  .text-title {
    font-size: 30px;
    font-weight: 700;
    color: #18181b;
    text-align: center;
    margin-bottom: 46px;

    @media screen and (min-width: 1200px) {
      font-size: 52px;
      margin-bottom: 82px;
    }
  }

  .text-sub {
    font-size: 18px;
    color: #18181b;
    text-align: center;
    line-height: 27px;
    margin-bottom: 46px;

    span {
      font-weight: 700;
    }

    @media screen and (min-width: 1200px) {
      font-size: 23px;
      line-height: 34px;
      margin-bottom: 62px;
    }
  }

  .marquee {
    height: 277px;
    background: url(~@/assets/img/aitutorplus/con7/img.png) repeat-x center /
      2497px 277px;
    animation: 20s marquee infinite linear;

    @media screen and (min-width: 1200px) {
      max-width: 2000px;
      margin: 0 auto;
    }
  }
}

@keyframes marquee {
  0% {
    background-position-x: 0%;
  }

  100% {
    background-position-x: 100%;
  }
}
</style>
